export default __webpack_public_path__ + "3bba603a3a1f6f31de74b757b4411041.svg";